/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'gslb';
const componentName = 'gslb-third-party-site-config';
const prefix = `${moduleName}.${componentName}`;

export const overridePoolMemberRatioLabel = `${prefix}.overridePoolMemberRatioLabel`;

export const ENGLISH = {
    [overridePoolMemberRatioLabel]: 'Override Pool Member Ratio',
};
